<div class="slide__copy">
  <ng-content select="[copy]"></ng-content>
</div>

<!-- The illustration column. Inert by construction: it projects whatever the
     pane hands it, and no pane hands it a control. -->
<div class="slide__viz">
  <div class="slide__vinner">
    <ng-content select="[viz]"></ng-content>
  </div>
</div>
